import { Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { OneTimePasswordComponent } from './one-time-password/one-time-password.component';
import { AuthorizeLoginComponent } from './authorize-login/authorize-login.component';
import { SilentRefreshComponent } from './silent-refresh/silent-refresh.component';

export const LOGIN_ROUTES: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        data: {
            authorities: [],
            pageTitle: 'login.tab.title'
        },
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        data: {
            authorities: [],
            pageTitle: 'login.tab.title'
        },
    },
    {
        path: 'reset-password/:token',
        component: ResetPasswordComponent,
        data: {
            authorities: [],
            pageTitle: 'login.tab.title'
        },
    },
    {
        path: 'one-time-password',
        component: OneTimePasswordComponent,
        data: {
            authorities: [],
            pageTitle: 'login.tab.title'
        },
    },
    {
        path: 'authorize-login',
        component: AuthorizeLoginComponent,
        data: {
            authorities: [],
            pageTitle: 'login.tab.title'
        },
    },
    {
        path: 'silent-refresh',
        component: SilentRefreshComponent,
        data: {
            authorities: [],
            pageTitle: 'login.tab.title'
        },
    },
];
